import BarcodeScannerButton from "./BarcodeScannerButton";

export default BarcodeScannerButton;
